import { useT } from "~/i18n";
import { Icon } from "./icon";

export function OverflowCues({
  canPrev,
  canNext,
  onPrev,
  onNext,
}: {
  canPrev: boolean;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}) {
  const t = useT();
  if (!canPrev && !canNext) return null;
  return (
    <>
      {canPrev ? (
        <button
          type="button"
          className="overflow-cue overflow-cue--prev"
          tabIndex={-1}
          aria-label={t("tabs.scrollPrev")}
          onClick={onPrev}
        >
          <Icon name="chevronLeft" size={16} />
        </button>
      ) : null}
      {canNext ? (
        <button
          type="button"
          className="overflow-cue overflow-cue--next"
          tabIndex={-1}
          aria-label={t("tabs.scrollNext")}
          onClick={onNext}
        >
          <Icon name="chevronRight" size={16} />
        </button>
      ) : null}
    </>
  );
}
